import React from 'react';

export enum YAxisRangeStartType {
  Zero = 'Zero',
  MinValue = 'MinValue',
}

export type GraphComponentDataFormatType = {
  graphKey: string;
  xAxisValueKey: string;
  checkboxLabel?: string;
  initiallySelected?: boolean;
  data: any[] | undefined;
  themeColor?: string;
};

export interface GraphComponentProps {
  graphData: GraphComponentDataFormatType[];
  loading: boolean;
  title?: string;
  description?: string;
  axisLine?: boolean;
  xAxisTickFormatter: (value: any) => string;
  tooltipFormatter?: (value: any) => string;
  multipleGraphChart?: boolean;
  yAxisTickFormatter: (value: any) => string;
  yAxisValueKey: string;
  yAxisLabelText?: string;
  yAxisRangeStart?: YAxisRangeStartType;
  yAxisTick?: (props: any) => React.ReactElement;
}

export type TimeFrameType = {
  label: string;
  days: number;
  formatter: (value: any) => string;
};

export enum TimeFrameTypes {
  'week' = '1 w',
  'month' = '1 mo',
  'quarter' = '3 mo',
  'year' = '1 yr',
  'all' = 'All time',
}
